import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { withStyles } from '@material-ui/core/styles';
import { TotalShiftsBooked } from '../TotalShiftsBooked/TotalShiftsBooked.js';
import { TotalHoursBooked } from '../TotalHoursBooked/TotalHoursBooked.js';
import { AssignedLabour } from '../AssignedLabour/AssignedLabour.js';
var Expander = withStyles({
  root: {
    order: 2
  },
  content: {
    flexGrow: 0
  }
})(AccordionSummary);
var Forecast = withStyles({
  root: {
    display: 'flex',
    'flex-direction': 'column',
    boxShadow: 'none',
    fontFamily: ['Lato']
  }
})(Accordion);
var Rows = withStyles({
  root: {
    display: 'grid',
    'grid-template-columns': '200px repeat(7, minmax(0, 1fr))',
    'grid-template-rows': 'auto',
    padding: 0
  }
})(AccordionDetails);

var WeeklyForecast = function WeeklyForecast(_ref) {
  var isAgency = _ref.isAgency,
      from = _ref.from,
      events = _ref.events;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleChange = function handleChange(panel) {
    return function (event, newExpanded) {
      setExpanded(newExpanded ? panel : false);
    };
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Forecast, {
    square: true,
    expanded: expanded === 'panel1',
    onChange: handleChange('panel1')
  }, /*#__PURE__*/React.createElement(Expander, {
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, !expanded ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Show Forecast Tools"), /*#__PURE__*/React.createElement(AddIcon, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Hide Forecast Tools"), /*#__PURE__*/React.createElement(RemoveIcon, null))), /*#__PURE__*/React.createElement(Rows, null, /*#__PURE__*/React.createElement(TotalShiftsBooked, {
    isAgency: isAgency,
    from: from,
    eventsByDate: events
  }), /*#__PURE__*/React.createElement(TotalHoursBooked, {
    isAgency: isAgency,
    from: from,
    eventsByDate: events
  }), /*#__PURE__*/React.createElement(AssignedLabour, {
    isAgency: isAgency,
    from: from,
    eventsByDate: events
  }))));
};

export { WeeklyForecast };